<!--The content below is only a placeholder and can be replaced.-->
<app-version-popup></app-version-popup>
<router-outlet></router-outlet>
<app-announcement-host></app-announcement-host>
